export const PAYMENT_FR_MAP = {
  "Bon de caisse":  { en: "Cash" },
  "Chèque":         { en: "Cheque" },      
  "Virement":       { en: "Transfer" },
  "Carte bancaire": { en: "Card" },
  "Versement":      { en: "Deposit" },       
  "Effet":          { en: "Bill of exchange" }, 
};

const NORM = (s) =>
  (s ?? "")
    .toString()
    .normalize("NFD").replace(/\p{Diacritic}+/gu, "")
    .toLowerCase().replace(/\s+/g, " ").trim();

const FR_SYNONYM_TO_KEY = new Map([
  [NORM("Dépôt"),              "Versement"],
  [NORM("Depot"),              "Versement"],
  [NORM("Versement bancaire"), "Versement"],

  [NORM("Carte"),              "Carte bancaire"],
  [NORM("Carte de crédit"),    "Carte bancaire"],

  [NORM("Virement bancaire"),  "Virement"],

  [NORM("Chèque bancaire"),    "Chèque"],
  [NORM("Cheque bancaire"),    "Chèque"],
  [NORM("Cheque"),             "Chèque"],
  [NORM("Check"),              "Chèque"],

  [NORM("Espèce"),             "Bon de caisse"],
  [NORM("Espèces"),            "Bon de caisse"],
  [NORM("Espece"),             "Bon de caisse"],
  [NORM("Argent liquide"),     "Bon de caisse"],

  [NORM("Traite"),             "Effet"],
  [NORM("Draft"),              "Effet"],
  [NORM("Bill of exchange"),   "Effet"],
  [NORM("Lettre de change"),   "Effet"],
]);

const FR_KEY_INDEX = new Map(
  Object.keys(PAYMENT_FR_MAP).map((fr) => [NORM(fr), fr])
);

export function resolveLang(input) {
  const raw = typeof input === "string" ? input : input?.resolvedLanguage || input?.language;
  return (raw ?? "").toLowerCase().startsWith("fr") ? "fr" : "en";
}

export function toFrenchKey(anyLabel) {
  const norm = NORM(anyLabel);
  const exact = FR_KEY_INDEX.get(norm);
  if (exact) return exact;
  const viaSyn = FR_SYNONYM_TO_KEY.get(norm);
  if (viaSyn) return viaSyn;
  return anyLabel?.toString() ?? "";
}

export function displayLabel(frKey, lang = "fr") {
  if (!frKey) return "";
  if (lang === "fr") return frKey;
  const en = PAYMENT_FR_MAP[frKey]?.en;
  return en || frKey; 
}

export function buildOptionsFromFrenchRows(rows, { lang } = {}) {
  const l = resolveLang(lang);
  const seen = new Set();
  const out = [];
  for (const r of rows ?? []) {
    const raw = (typeof r === "string") ? r : (r?.label ?? r?.name ?? r?.value ?? "");
    const frKey = toFrenchKey(raw);
    if (!frKey || seen.has(frKey)) continue;
    seen.add(frKey);
    out.push({ value: frKey, label: displayLabel(frKey, l) });
  }
  return out;
}

export function parseFrenchPieceStringToKeys(pieceStr) {
  return (pieceStr || "")
    .split(";")
    .map(s => s.trim())
    .filter(Boolean)
    .map(toFrenchKey);
}

export function joinFrenchKeys(keys) {
  return (keys || []).filter(Boolean).join(";");
}
